import * as fromDatatype from '../datatype-library/index';

export interface bl_sch_crontab_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  cron_expression: fromDatatype.VarcharDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  last_run_time: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_sch_crontab_hdr_RowClass implements bl_sch_crontab_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  cron_expression: fromDatatype.VarcharDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  last_run_time: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
